export const IMAGE_BASE_URL = "https://belenbai.mn/";
